import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./assets/css/index.scss";
import { ThemeProvider } from "@material-tailwind/react";
import { customTheme } from "@/theme/customTheme.ts";
import "./sentry.config.ts";

ReactDOM.createRoot(document.getElementById("trio")!).render(
  <ThemeProvider value={customTheme}>
    <App />
  </ThemeProvider>,
);
